import * as React from 'react';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';

import * as styles from './NewbuildingBlackFridayTopBanner.css';

export function NewbuildingBlackFridayTopBanner() {
  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <div className={styles['text']}>
        <ArticleHeading4 color="white_100">Предложения чёрной пятницы 16–24 ноября</ArticleHeading4>
        <ArticleParagraph2 color="white_100">Выберите ЖК и позвоните по номеру в объявлении</ArticleParagraph2>
      </div>
    </div>
  );
}
